import { useEffect, useState } from "react";
import {
  InputCoBis,
  OutputCoBis,
} from "../../../Services/Serverless/Lookup/Co/Co.interface";
import { QueueMethods } from "../../../Services/Serverless/Queue/Queue.interface";
import Loading from "../../Infrastructure/Loading";
import pollingQueue from "../../../Services/Serverless/pollingQueue";

export default function CosBis({ bin }: { bin: string }) {
  const [cos, setCos] = useState<OutputCoBis | undefined>(undefined);
  useEffect(() => {
    const method = QueueMethods.COS_BIS;
    const inputData = { dobbin: bin };
    const intervalHandle = pollingQueue<InputCoBis, OutputCoBis>({
      method,
      input: inputData,
      setData: setCos,
    });
    return () => {
      if (intervalHandle) clearInterval(intervalHandle);
    };
  }, []);
  return (
    <div className="cos">
      <h3>DOB Building Information System</h3>
      {cos === undefined ? (
        <Loading />
      ) : (
        <>
          {cos.pdfLinks.length === 0 ? (
            <div>No certificate of occupancy found</div>
          ) : (
            <>
              {cos.pdfLinks.map((pdfLink, i) => (
                <div key={pdfLink.url + i}>
                  <a href={pdfLink.url} target="_blank" rel="noreferrer">
                    {pdfLink.filename}
                  </a>
                </div>
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
}
